// City-specific pricing data for self-drive and local cab services

// Self-drive rental pricing by city
export const selfDrivePricing = {
  chandigarh: [
  {
    name: 'Maruti Dzire',
    price: 5000,
    baggage: 3,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta',
    price: 10000,
    baggage: 6,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Maruti Ertiga',
    price: 5000,
    baggage: 4,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Fortuner',
    price: 9000,
    baggage: 5,
    seater: 6,
    image: "https://images.unsplash.com/photo-1651742425034-8bf38f70f746",
    alt: 'Toyota Fortuner luxury SUV with powerful performance and premium interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Hycross',
    price: 9000,
    baggage: 5,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Hybrid',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Brezza',
    price: 5500,
    baggage: 4,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Urbania',
    price: 15000,
    baggage: 9,
    seater: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png",
    alt: 'Force Urbania luxury van for group travel with premium interiors',
    details: {
      seatingCapacity: '12+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Kia Carens',
    price: 7500,
    baggage: 5,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png',
    alt: 'Kia Carens premium MPV with modern styling and comfortable interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol & Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta 7+1',
    price: 5500,
    baggage: 6,
    seater: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
    alt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel',
    details: {
      seatingCapacity: '7+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking is not included.'
    }
  }],

  mohali: [
  {
    name: 'Maruti Dzire',
    price: 2000,
    baggage: 3,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta',
    price: 6000,
    baggage: 6,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Maruti Ertiga',
    price: 5500,
    baggage: 4,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Fortuner',
    price: 10000,
    baggage: 5,
    seater: 6,
    image: "https://images.unsplash.com/photo-1651742425034-8bf38f70f746",
    alt: 'Toyota Fortuner luxury SUV with powerful performance and premium interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Hycross',
    price: 6000,
    baggage: 5,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Hybrid',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Brezza',
    price: 5500,
    baggage: 4,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Urbania',
    price: 15000,
    baggage: 9,
    seater: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png",
    alt: 'Force Urbania luxury van for group travel with premium interiors',
    details: {
      seatingCapacity: '12+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Kia Carens',
    price: 6000,
    baggage: 5,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png',
    alt: 'Kia Carens premium MPV with modern styling and comfortable interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol & Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta 7+1',
    price: 8000,
    baggage: 6,
    seater: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
    alt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel',
    details: {
      seatingCapacity: '7+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking is not included.'
    }
  }],

  panchkula: [
  {
    name: 'Maruti Dzire',
    price: 2500,
    baggage: 3,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta',
    price: 7000,
    baggage: 6,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Maruti Ertiga',
    price: 5000,
    baggage: 4,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'CNG & Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Fortuner',
    price: 9000,
    baggage: 5,
    seater: 6,
    image: "https://images.unsplash.com/photo-1651742425034-8bf38f70f746",
    alt: 'Toyota Fortuner luxury SUV with powerful performance and premium interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Hycross',
    price: 9000,
    baggage: 5,
    seater: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Hybrid',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Brezza',
    price: 5500,
    baggage: 4,
    seater: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design',
    details: {
      seatingCapacity: '4+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Urbania',
    price: 15000,
    baggage: 9,
    seater: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png",
    alt: 'Force Urbania luxury van for group travel with premium interiors',
    details: {
      seatingCapacity: '12+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Kia Carens',
    price: 7500,
    baggage: 5,
    seater: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png',
    alt: 'Kia Carens premium MPV with modern styling and comfortable interiors',
    details: {
      seatingCapacity: '6+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol & Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  },
  {
    name: 'Innova Crysta 7+1',
    price: 6000,
    baggage: 6,
    seater: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
    alt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel',
    details: {
      seatingCapacity: '7+1',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-300 Extra)',
      airportParking: 'Airport parking is not included.'
    }
  }]

};

// Local cab pricing by city
export const localCabPricing = {
  noida: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  rajpura: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  chandigarh: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  delhi: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  ghaziabad: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  faridabad: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  kharar: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  mohali: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  panchkula: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  zirakpur: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  mohaliairport: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  'new-chandigarh': [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  'delhi-airport': [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  'greater-noida': [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  'chandigarh-airport': [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 2100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 2500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3000,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 4200,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }],

  gurgaon: [
  {
    type: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 3000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    type: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 3500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    type: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 3800,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png',
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    type: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 4500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    type: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 5500,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  }]

};